import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, ArrowRight } from "lucide-react";
import { useCompanyInfo } from "@/hooks/use-company-info";

export const CTASection = React.forwardRef<HTMLElement>((_, ref) => {
  const { phone } = useCompanyInfo();
  const phoneLink = `tel:${phone.replace(/[^0-9+]/g, "")}`;
  return (
    <section ref={ref} className="py-20 bg-primary text-primary-foreground">
      <div className="container text-center">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
          Ready to Find Your Perfect Property?
        </h2>
        <p className="text-primary-foreground max-w-2xl mx-auto mb-8 text-lg opacity-90">
          Whether you're looking for a vacation getaway, commercial space, or your next home, we're here to help make it happen.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button size="lg" variant="secondary" asChild>
            <Link to="/properties">
              Browse Properties
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <Button size="lg" variant="outline" asChild className="bg-transparent border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10">
            <a href={phoneLink}>
              <Phone className="mr-2 h-4 w-4" />
              Call Us Today
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
});

CTASection.displayName = "CTASection";
